<form [formGroup]="fgNewCNF" (ngSubmit)="mode === 'create' ? onNewCNFSubmit() : onUpdateClick()">
  <aux-modal primaryButtonType="submit" [loading]="loading()">
    @if (mode === 'create') {
      <div>
        @for (tab of tabs; track tab; let i = $index) {
          @if (tab.show | async) {
            <button
              type="button"
              class="mb-2 whitespace-nowrap border-b-2 px-1 py-4 text-sm font-medium focus:outline-none"
              [ngClass]="{
                'border-aux-blue-light text-aux-blue-light': i === activeTabIndex,
                'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700':
                  i !== activeTabIndex,
              }"
              (click)="onTabChange(i)"
            >
              {{ tab.label }}
            </button>
          }
        }
      </div>
    }

    @if (activeTabIndex === 0) {
      <div>
        <div class="max-h-158 overflow-y-auto">
          <div class="ml-1 mr-1 grid max-w-[520px] grid-cols-6 gap-5">
            <aux-input
              label="CNF #"
              formControlName="cnf_no"
              class="col-span-2"
              placeholder="#"
              [validators]="getCnfValidators"
              [customErrorMessages]="customErrorMessages"
            />
            <aux-input
              label="Request Date"
              formControlName="request_date"
              class="col-span-2"
              placeholder="YYYY-DD-MM"
              [type]="'date'"
              [validators]="getDateValidator"
            />
            <aux-input
              label="Approved Date"
              formControlName="start_date"
              class="col-span-2"
              placeholder="YYYY-DD-MM"
              [type]="'date'"
              [validators]="getDateValidator"
            />
            <aux-input
              label="Description"
              formControlName="description"
              class="col-span-6"
              [textArea]="true"
              resize="none"
            />

            <aux-input
              label="Services"
              formControlName="service_fee"
              placeholder="$"
              class="col-span-2"
              [validators]="getMustNumericValidator"
            />

            <aux-input
              label="Pass-through"
              formControlName="passthrough_fee"
              placeholder="$"
              class="col-span-2"
              [validators]="getMustNumericValidator"
            />

            <aux-input
              label="Investigator"
              formControlName="investigator_fee"
              placeholder="$"
              class="col-span-2"
              [validators]="getMustNumericValidator"
            />

            <div class="aux-select col-span-2">
              <label for="vendor">Requester</label>
              <ng-select
                id="vendor2"
                class="select select__big"
                formControlName="requester"
                bindValue="id"
                bindLabel="requester"
                required
                auxFormError
                label="Requester"
                [clearable]="false"
                [searchable]="false"
              >
                <ng-option [value]="'REQUESTER_VENDOR'">Vendor Contract</ng-option>
                <ng-option [value]="'REQUESTER_SPONSOR'">Sponsor</ng-option>
                <ng-option [value]="'REQUESTER_JOINT'">Joint</ng-option>
              </ng-select>
            </div>

            <div class="aux-select col-span-2">
              <label for="change_order_no">Change Order #</label>
              <ng-select
                id="change_order_no"
                class="select select__big"
                formControlName="change_order_reference"
                bindValue="id"
                bindLabel="change_order_no"
                auxFormError
                label="Change Order No"
                [clearable]="true"
                [searchable]="false"
              >
                @for (changeOrder of changeOrdersNumbers; track changeOrder) {
                  <ng-option [value]="changeOrder.id">
                    <span [title]="changeOrder.change_order_no">
                      {{ changeOrder.change_order_no }}
                    </span>
                  </ng-option>
                }
              </ng-select>
            </div>

            <div class="aux-select col-span-2">
              <label for="change_log_status">Status</label>
              <ng-select
                id="change_log_status"
                class="select select__big"
                formControlName="change_log_item_status"
                bindValue="changeLogStatus"
                bindLabel="status"
                auxFormError
                label="Status"
                [clearable]="false"
                [searchable]="false"
              >
                @for (status of this.statusConstant; track status) {
                  <ng-option [value]="status.value">
                    <div class="flex items-center whitespace-nowrap">
                      <div class="mr-1 h-3 w-3 rounded-full" [ngClass]="status.circleClass"></div>
                      <div [ngClass]="status.textClass">{{ status.text }}</div>
                    </div>
                  </ng-option>
                }
              </ng-select>
            </div>

            <aux-input
              label="Cause"
              formControlName="cause"
              placeholder="Cause"
              class="col-span-4"
              [type]="'text'"
            />

            <div class="aux-select col-span-2">
              <label for="vendor">Type</label>
              <ng-select
                id="vendor"
                formControlName="is_planned"
                bindValue="id"
                bindLabel="is_planned"
                [clearable]="false"
                [searchable]="false"
                [appendTo]="'body'"
              >
                <ng-option [value]="true">Planned</ng-option>
                <ng-option [value]="false">Unplanned</ng-option>
              </ng-select>
            </div>

            <div class="aux-select h-18 col-span-6">
              <label for="file">Upload CNF documents here</label>
              <div id="file">
                <aux-file-manager
                  #manager
                  class="h-24"
                  [pathFn]="getFilePathForCisItems()"
                  [metadataFn]="getMetadata()"
                  [eager]="false"
                  [showSuccessOnUpload]="true"
                />
                <div class="h-18 mt-2 overflow-auto">
                  <aux-file-viewer
                    [fileManager]="manager"
                    [disableFirstFileMargin]="true"
                    [onlyShowUploaded]="false"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  </aux-modal>
</form>
